import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { from, Observable, take } from 'rxjs';
import { ClientSubsidy } from 'src/app/api/contracts/client';
import { ClientService } from 'src/app/services/client.service';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-subsidies',
  templateUrl: './subsidies.component.html',
  styleUrls: ['./subsidies.component.scss'],
})
export class SubsidiesComponent implements OnInit {
  public readonly subsidies$: Observable<ClientSubsidy[]>;
  constructor(
    private readonly navCtrl: NavController,
    private readonly clientService: ClientService,
    private readonly modalService: ModalService
  ) {
    this.subsidies$ = this.clientService.clientSubsidies$;
  }

  ngOnInit() {
    this.clientService.retrieveClientSubsidies().subscribe();
  }

  onBackButtonClick(): void {
    from(this.navCtrl.pop()) // pop() already makes back navigation
      .pipe(take(1))
      .subscribe((hasHistory) => {
        if (!hasHistory) {
          this.navCtrl.navigateRoot('/orders');
        }
      });
  }

  onActivateCodeClick(): void {
    this.modalService
      .showSubsidyCodeActivationModal()
      .subscribe((isCodeSent) => {
        if (!isCodeSent) {
          return;
        }
        this.clientService.retrieveClientSubsidies().subscribe();
      });
  }
}
